import { render } from "./LeaveReviewView.vue?vue&type=template&id=35449136&scoped=true"
import script from "./LeaveReviewView.vue?vue&type=script&lang=js"
export * from "./LeaveReviewView.vue?vue&type=script&lang=js"

import "./LeaveReviewView.vue?vue&type=style&index=0&id=35449136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35449136"]])

export default __exports__